import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useDecodedToken } from '../app/hooks';
import { useGetLogoPathQuery } from '../api/apiSlice';
import { handleImageError, PLACEHOLDER_IMAGE } from '../utils/imageFallback';

const DISPLAY_MS = 1800;

export default function Welcome() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const decodedToken = useDecodedToken();
    const clubId = decodedToken?.clubId;

    const { data: logoRows } = useGetLogoPathQuery(clubId != null ? String(clubId) : '', { skip: clubId == null });
    const logoPath = logoRows?.[0]?.LOGO;

    useEffect(() => {
        const timer = setTimeout(() => navigate('/activities', { replace: true }), DISPLAY_MS);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                gap: 3,
                textAlign: 'center',
            }}
        >
            <Zoom in timeout={600}>
                <Box
                    component="img"
                    src={logoPath || PLACEHOLDER_IMAGE}
                    onError={handleImageError}
                    alt=""
                    sx={{ maxWidth: 220, maxHeight: 220 }}
                />
            </Zoom>
            <Typography variant="h5">{t('welcome.title')}</Typography>
        </Box>
    );
}
